import { json } from 'stream/consumers';

export function loadState(): any | undefined {
  try {
    const serializedTokenState = localStorage.getItem('token');
    const serializedUserState = localStorage.getItem('currentUser');
    const serializedWorkspaceState = localStorage.getItem('workspaces') || '[]';

    const lastActiveWorkspace = localStorage.getItem('last-active:workspace');
    const sessionWorkspace = sessionStorage.getItem('workspace') || lastActiveWorkspace;

    const workpaceState = JSON.parse(serializedWorkspaceState);
    const activeWorkspace = workpaceState.find((workspace: any) => workspace.workspace_id === sessionWorkspace);

    if (!serializedTokenState || !serializedUserState || !serializedWorkspaceState) {
      return undefined;
    }
    const tokenState = JSON.parse(serializedTokenState);
    const workspaceUser = activeWorkspace?.user;

    return {
      token: tokenState,
      user: { user: workspaceUser },
      workspace: workpaceState
    };
  } catch (err) {
    return undefined;
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function saveState(state: any): void {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore write errors. The app will initialize just fine.
  }
}
